import React, { useContext, useEffect } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom'; // Utilisez Navigate pour la redirection
import { AuthContext } from './AuthContext'; // Assurez-vous du chemin correct pour le contexte

const ProtectedRoute = () => {
  const { authState, setRedirectToLogin } = useContext(AuthContext);
  const navigate = useNavigate();

  if (!authState.isAuthenticated) {
    //setRedirectToLogin(window.location.pathname); // Enregistrer l'URL d'origine
    navigate('/login');
  }

  return <Outlet />;
};

export default ProtectedRoute;
